import classNames from 'classnames';

export const genClassName = (defaultClass, additionalClasses) => classNames(defaultClass, additionalClasses);



// WEBPACK FOOTER //
// ./src/utils/helpers.js